import { Typography } from '@material-ui/core';
import Layout from './Layout';

function PersonalDataPolicy() {
    return (
        <Layout>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '0 16px' }}>
                <Typography variant='h4'>
                    СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
                </Typography>
                <Typography variant='body1'>
                    Я, субъект персональных данных, в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» свободно,
                    в своей воле и в своем интересе, а также подтверждая свою дееспособность даю согласие ООО «Гипер», расположенному
                    по адресу 196210, г. Санкт Петербург, ул. Шереметьевская, дом 13, литера А, офис 502, (далее – Оператор), на
                    обработку персональных данных на следующих условиях:
                </Typography>
                <Typography variant='body1'>
                    Согласие дается на обработку персональных данных, как без использования средств автоматизации, так и с их
                    использованием.
                </Typography>
                <Typography variant='body1'>
                    Цель обработки персональных данных:
                </Typography>
                <Typography variant='body1'>
                    поставка товаров/оказание услуг/выполнение работ в соответствии с договором.
                </Typography>
                <Typography variant='body1'>
                    Согласие дается на обработку следующих персональных данных:
                </Typography>
                <Typography variant='body1'>
                    Распространяется на данные, указанные в договоре, а также на данные, полученные в результате его исполнения
                </Typography>
                <Typography variant='body1'>
                    Разрешенные действия в отношении персональных данных:
                </Typography>
                <Typography variant='body1'>
                    Настоящее согласие предоставляется на осуществление любых действий в отношении моих персональных данных, которые
                    необходимы или желаемы для достижения указанных выше целей, включая (без ограничения) сбор, запись, систематизацию,
                    накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование,
                    удаление, уничтожение персональных данных, поручение обработки:
                </Typography>
            </div>
            <div style={{ overflowX: 'auto', padding: '0 16px' }}>
                <table style={{ marginLeft: '0pt', background: '#ffffff', borderCollapse: 'collapse', width: '100%', minWidth: 700, marginTop: 40, marginBottom: 40, border: '1px solid #000000', }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', fontWeight: 'bold' }}>
                                <Typography variant="body2">Цель обработки</Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', fontWeight: 'bold' }}>
                                <Typography variant="body2">Третьи лица, их местоположение и ссылка на политику конфиденциальности / веб-сайт, если это применимо</Typography>
                            </td>
                            <td style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', fontWeight: 'bold' }}>
                                <Typography variant="body2">Цель передачи</Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', fontWeight: 'bold' }}>
                                <Typography variant="body2">Адрес третьего лица</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan={3} style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">Веб-аналитика, cookie и работа с сайтом</Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">ООО «Яндекс» (Россия),</Typography>
                                <Typography variant="body2">
                                    <a href="https://yandex.ru/legal/confidential/" title="https://yandex.ru/legal/confidential/">Политика конфиденциальности</a>
                                </Typography>
                            </td>
                            <td style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">Провайдер услуг веб-аналитики (Яндекс Метрика)</Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">119021, город Москва, ул. Льва Толстого, д. 16</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">ООО «К50» (Россия),</Typography>
                                <Typography variant="body2">
                                    <a href="https://legal.k50.ru/policy/" title="https://legal.k50.ru/policy/">Политика конфиденциальности</a>
                                </Typography>
                            </td>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">Провайдер услуг веб-аналитики (К50)</Typography>
                            </td>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">119021, город Москва, ул Тимура Фрунзе, д. 11 стр. 44, этаж/помещ. 5/II ком. 2</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">ООО «Майндбокс» (Россия),</Typography>
                                <Typography variant="body2">
                                    <a href="https://mindbox.ru/documents/policy/" title="https://mindbox.ru/documents/policy/">Политика обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">Провайдер услуг веб-аналитики (Mindbox)</Typography>
                            </td>
                            <td style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">125124, город Москва, ул Правды, д. 26, эт/пом 12/XXX</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td rowSpan={3} style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Партнерский маркетинг на сайте онлайн-магазина
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Адв-Кейк»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://advcake.com/privacy-policy" title="https://advcake.com/privacy-policy">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    сервиса партнерского маркетинга
                                </Typography>
                                <Typography variant="body2">
                                    (Adv.Cake)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    123001,
                                    город Москва, Большая Садовая ул., д. 5 к. 1, этаж 4, помещ 2038
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО «СПАРТА»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.admitad.ru/privacy/" title="https://www.admitad.ru/privacy/">Политика
                                        обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    сервиса партнерского маркетинга
                                </Typography>
                                <Typography variant="body2">
                                    (Admitad)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    127015,
                                    город Москва, ул. Новодмитровская д.2, корп. 1, этаж 6.
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Флоктори»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.flocktory.com/assets/documents/privacy_policy-23.pdf"
                                        title="https://www.flocktory.com/assets/documents/privacy_policy-23.pdf">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    сервиса партнерского маркетинга
                                </Typography>
                                <Typography variant="body2">
                                    (Admitad)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    125167,
                                    город Москва, Ленинградский
                                    пр-кт, д. 36 стр. 11
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={4}
                                style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Поддержка
                                    сайта и взаимодействие с пользователями
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ЗАО
                                    «Группа СЕБ-Восток»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://tefal.ru/politika-konfidencialnosti"
                                        title="https://tefal.ru/politika-konfidencialnosti">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Поддержка
                                </Typography>
                                <Typography variant="body2">
                                    сайта
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    125171,
                                    город Москва, Ленинградское ш., д. 16а стр. 3, помещ. XII
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Селектел»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://files.selectel.ru/docs/ru/personal-data-processing-and-protection-policy.pdf?_gl=1*jlpoo8*_ga*MTU4MDIzNTYxNy4xNzE4Mjg0NDU1*_ga_H3R3VJH01B*MTcxODI4NDQ1NC4xLjAuMTcxODI4NDQ1NC42MC4wLjA."
                                        title="https://files.selectel.ru/docs/ru/personal-data-processing-and-protection-policy.pdf?_gl=1*jlpoo8*_ga*MTU4MDIzNTYxNy4xNzE4Mjg0NDU1*_ga_H3R3VJH01B*MTcxODI4NDQ1NC4xLjAuMTcxODI4NDQ1NC42MC4wLjA.">Политика
                                        в отношении обработки и защиты персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    хостинга сайта
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    196006,
                                    город Санкт-Петербург, ул. Цветочная, д. 21, лит А
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «МАСТЕР БОТ» (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://fstrk.io/privacy_policy" title="https://fstrk.io/privacy_policy">Политика
                                        обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    виджета онлайн-чата и бота на сайте (Fasttrack)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    109125,
                                    Москва, ул. Васильцовский стан, д.5, к.1, кв. 194
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Живой Сайт»(Россия) <a
                                        href="chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/www.jivo.ru/files/personal_data_processing_policy.pdf"
                                        title="chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/www.jivo.ru/files/personal_data_processing_policy.pdf">Политика
                                        в отношении обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    виджета онлайн-чата на сайте (JivoSite)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115280,
                                    город Москва, ул. Ленинская Слобода, д. 19, офис 21г1
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={6}
                                style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Прием
                                </Typography>
                                <Typography variant="body2">
                                    платежей
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ПАО
                                    «Совкомбанк»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://sovcombank.ru/about/pages/policy-personal-data"
                                        title="https://sovcombank.ru/about/pages/policy-personal-data">Политика
                                        обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    156000,
                                    Костромская область, город Кострома, пр-кт Текстильщиков,
                                    д. 46
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    АО
                                    «ПЛАЙТ» (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://plait.ru/docs/personal_data_processing_policy.pdf"
                                        title="https://plait.ru/docs/personal_data_processing_policy.pdf">Политика
                                        обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса (Плайт)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    156000,
                                    Костромская область, г. Кострома, ул. Ленина, д. 20, помещ. 4, ком. 73.
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    АО
                                    «НСПК»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.nspk.ru/about/processing-of-personal-data"
                                        title="https://www.nspk.ru/about/processing-of-personal-data">Политика
                                        обработки и защиты персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса
                                </Typography>
                                <Typography variant="body2">
                                    (СБП)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115184,
                                    город Москва, Большая Татарская ул., д. 11
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Всегда Да»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://vsegda-da.com/policy" title="https://vsegda-da.com/policy">Политика
                                        в отношении обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    125124,
                                    город Москва, ул Правды, д. 8 к. 1
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    АО
                                    «Яндекс Банк»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://yandex.ru/legal/ord_conf/index.html"
                                        title="https://yandex.ru/legal/ord_conf/index.html">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса
                                </Typography>
                                <Typography variant="body2">
                                    (Яндекс
                                    Пэй)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115035,
                                    город Москва, Садовническая ул, д. 82 стр. 2
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Яндекс Пэй»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://yandex.ru/legal/ord_conf/index.html"
                                        title="https://yandex.ru/legal/ord_conf/index.html">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Предоставление
                                    платежного сервиса
                                </Typography>
                                <Typography variant="body2">
                                    (Яндекс
                                    Сплит)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115035,
                                    город Москва, Садовническая ул, д. 82 стр. 2, помещ. 5в26
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={8}
                                style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">Доставка
                                    товаров
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Яндекс.Доставка»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://yandex.ru/legal/confidential/index.html"
                                        title="https://yandex.ru/legal/confidential/index.html">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов (Яндекс.Доставка)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    123112,
                                    город Москва, 1-Й Красногвардейский проезд, д. 22 стр. 1, этаж 13 помещ. 13-40
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    АО
                                    «ДПД РУС»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://old.dpd.ru/docs/ru/privacy.pdf"
                                        title="https://old.dpd.ru/docs/ru/privacy.pdf">Политика
                                        в отношении обработки и защиты персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (DPD)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    107023,
                                    город Москва, Электрозаводская ул, д. 27 стр. 8
                                </Typography>
                                <Typography variant="body2">

                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Логсис Групп»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/logsis.ru/policy.pdf"
                                        title="chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/logsis.ru/policy.pdf">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (Логсис)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    117105,
                                    город Москва, Нагорный пр-д, д. 3 стр. 4, этаж 2 офис 201
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Далли-Сервис»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://dalli-service.com/politika-konfidenczialnosti/"
                                        title="https://dalli-service.com/politika-konfidenczialnosti/">Политика
                                        в отношении обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (Dalli-Service)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    119361,
                                    город Москва, Озёрная ул., д. 42, помещ. II комната 16
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    АО
                                    «Почта России»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.pochta.ru/documents/10231/86671986/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0+%D1%84%D0%B5%D0%B4%D0%B5%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE+%D0%B3%D0%BE%D1%81%D1%83%D0%B4%D0%B0%D1%80%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE+%D1%83%D0%BD%D0%B8%D1%82%D0%B0%D1%80%D0%BD%D0%BE%D0%B3%D0%BE+%D0%BF%D1%80%D0%B5%D0%B4%D0%BF%D1%80%D0%B8%D1%8F%D1%82%D0%B8%D1%8F+%D0%9F%D0%BE%D1%87%D1%82%D0%B0+%D0%A0%D0%BE%D1%81%D0%B8%D0%B8+%D0%B2+%D1%81%D1%84%D0%B5%D1%80%D0%B5+%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8+%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85+%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85.pdf/818d34d6-0df1-4054-acc5-73f78dce7117"
                                        title="https://www.pochta.ru/documents/10231/86671986/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0+%D1%84%D0%B5%D0%B4%D0%B5%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE+%D0%B3%D0%BE%D1%81%D1%83%D0%B4%D0%B0%D1%80%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%BE%D0%B3%">Политика
                                        в отношении обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (Почта
                                    России)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    125252,
                                    город Москва, 3-Я Песчаная ул, д. 2а
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «СДЭК-Глобал»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.cdek.ru/ru/privacy_policy/"
                                        title="https://www.cdek.ru/ru/privacy_policy/">Политика
                                        в отношении обработки персональных данных субъектов персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (СДЭК)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    630007,
                                    Новосибирская область, город Новосибирск, Кривощековская ул., д. 15 к. 1, этаж 1,2
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «БиЭксБи Рус»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://boxberry.ru/castnym-klientam/mn-dostavka/personalnye-dannye"
                                        title="https://boxberry.ru/castnym-klientam/mn-dostavka/personalnye-dannye">Политика
                                        в отношении обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (Boxberry)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    127015,
                                    город Москва, Новодмитровская ул, д. 5а стр. 4, помещ. 1/1
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «5 ПОСТ»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://fivepost.ru/static/docs/privacyPolicy.html"
                                        title="https://fivepost.ru/static/docs/privacyPolicy.html">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг по
                                    доставке заказов
                                </Typography>
                                <Typography variant="body2">
                                    (5Post)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    109029,
                                    город Москва, Средняя Калитниковская ул., д. 28 стр. 4, эт 1 пом VIII ком 7
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={2}
                                style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Обработка
                                    заказа
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «АПИШИП»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    сервиса по обработке заказа
                                </Typography>
                                <Typography variant="body2">
                                    (ApiShip)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115432,
                                    город Москва, Проектируемый 4062-й пр-д,
                                    д. 6 стр. 1, эт 2 пом V ком 68
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «РитейлДрайвер»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия)
                                </Typography>
                                <Typography variant="body2">

                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    сервиса по обработке заказа
                                </Typography>
                                <Typography variant="body2">
                                    (RetailCRM)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    115230,
                                    город Москва, Хлебозаводский пр-д, д. 7 стр. 9, офис 501-1
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={4} style={{ width: '20%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Маркетинг
                                    и рассылки
                                </Typography>
                            </td>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Майндбокс»
                                </Typography>
                                <Typography variant="body2">
                                    (Россия),
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://mindbox.ru/documents/policy/" title="https://mindbox.ru/documents/policy/">Политика
                                        обработки персональных данных</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Провайдер
                                    услуг веб-аналитики (Mindbox)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    125124,
                                    город Москва, ул Правды, д. 26, эт/пом 12/XXX
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Сигмель»
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://segmel.com/privacypolicy" title="https://segmel.com/privacypolicy">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Анализ
                                    данных Клиентов
                                </Typography>
                                <Typography variant="body2">
                                    (Segmel)
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    105082,
                                    город Москва, Переведеновский пер, д. 13 стр. 18, помещ. 21н/3
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «ОККАМ ИСК» (Россия)
                                </Typography>
                                <Typography variant="body2">

                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Анализ
                                    и систематизация информации для направления информационной рассылки
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    121609,
                                    г. Москва, вн. тер., г. Муниципальный округ Крылатское, Осенний бульвар, д. 23, 4-ый этаж,
                                    помещение I, комната 9
                                </Typography>
                                <Typography variant="body2">

                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '30%', backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    ООО
                                    «Брендформанс»
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://brandformance.ltd/privacy" title="https://brandformance.ltd/privacy">Политика
                                        конфиденциальности</a>
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    Анализ
                                    и систематизация информации для разработки, планирования и реализации рекламных кампаний в
                                    Интернете, включая контекстную, таргетированную и медийную рекламу
                                </Typography>
                            </td>
                            <td
                                style={{ backgroundColor: '#ffffff', padding: '8px', border: '1px solid #000000', verticalAlign: 'top' }}>
                                <Typography variant="body2">
                                    196210,
                                    город Санкт-Петербург, Шереметьевская ул., д. 13 литера А, помещ.1-Н, офис 1
                                </Typography>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '0 16px' }}>
                <Typography variant='body1'>
                    Срок обработки:
                </Typography>
                <Typography variant='body1'>
                    Обработка персональных данных разрешается на срок действия договора, а в случае прекращения договора – в
                    соответствии с положениями Федерального закона № 152-ФЗ от 27.07.2006 года «О персональных данных».
                </Typography>
                <Typography variant='body1'>
                    Настоящее Согласие может быть отозвано мной в письменной форме.
                </Typography>
            </div>
        </Layout>
    );
}

export default PersonalDataPolicy;
